import { LanguagesState } from './languages.state';
import * as language 	from './languages.actions';

export const initialState: LanguagesState = {
  languages:['it','en'],
  selected: 'it'
};

export function languageReducer(state = initialState, action: language.Actions): LanguagesState {

	switch (action.type) {
    case language.GET_LANGUAGES:
			return {
				...state,
				languages:action.payload.languages,
        selected: action.payload.selected
			};
      case language.SET_LANGUAGE:
        return {
          ...state,
          selected: action.payload.lang
        };
        case language.SET_LANGUAGES:
          return {
            ...state,
            languages: action.payload.languages
          };
    default:
			return state;

  }
}
